// USAGE: import { #MODULE NAME# } from '@medscape-promo/medscapetv/omniture-tracking';

const EMBD_LNK = "mtv-embd-lnk";
const VIEWED_MODULES_TRACKING = {
	"mmodule": "mtv-module",
	"mlink": {
		"cast": "cast-list",
		"series-info": "series-info",
		"info-graphic": "info-graphic",
		"related-resources": "more-med" 
	}
}

const VIEW_VIDEO_PLAYER_TRACKING = {
	"mmodule": "mtv-module_jsx",
	"mlink": {
		"video-player": "video-player"
	}
}
const COMMENTS_TRACKING = {
	"mmodule": "mtv-comm",
	"mlink": {
		"open": "open",
		"close": "close"
	}
}

const TRANSCRIPTS_TRACKING = {
	"mmodule": "mtv-trns",
	"mlink": {
		"open": "open",
		"close": "close"
	}
}

const SHARE_TRACKING = {
	"mmodule": "mtv-share",
	"mlink": {
		"facebook": "face",
		"linkedin": "link",
		"twitter": "twit"
	}
}

const YOUTUBE_WIDGET_TRACKING = {
	"mmodule": "mtv",
	"mlink": {
		"click": "yt"
	}
}

const PLAYLIST_TRACKING = {
	"mmodule": "mtv-show",
	"mlink": {
		"next": "next",
		"prev": "prev"
	}
}

const MEDIA_TRACKING = {
	"mmodule": "vidmtv"
}
const ABOUT_SERIES_TRACKING = {
	"mmodule": {
		"expand": "mtv-more",
		"collapse": "mtv-less"
	}
}
export {
	YOUTUBE_WIDGET_TRACKING,
	COMMENTS_TRACKING,
	EMBD_LNK,
	VIEWED_MODULES_TRACKING,
	VIEW_VIDEO_PLAYER_TRACKING,
	SHARE_TRACKING,
	TRANSCRIPTS_TRACKING,
	PLAYLIST_TRACKING,
	MEDIA_TRACKING,
	ABOUT_SERIES_TRACKING
}